import { ReactNode } from 'react';

interface ChartCardProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
}

function ChartCard({ title, subtitle, action, children, className = '' }: ChartCardProps) {
  return (
    <div
      className={`min-w-0 rounded-xl border border-zt-border bg-zt-surface p-4 lg:p-5 ${className}`}
    >
      <div className="mb-4 flex min-w-0 flex-wrap items-start justify-between gap-2">
        <div className="min-w-0">
          <h3 className="text-sm font-semibold text-white lg:text-base">{title}</h3>
          {subtitle && <p className="mt-0.5 text-xs text-zt-muted">{subtitle}</p>}
        </div>
        {action}
      </div>
      <div className="min-w-0">{children}</div>
    </div>
  );
}

export default ChartCard;
